const setCookie = (key: string, value: string, days: number | undefined) => {
  const currentDate = new Date();
  if (days)
    currentDate.setTime(currentDate.getTime() + 24 * 60 * 60 * 1000 * days);

  document.cookie = `${key}=${value};path=/;${
    days ? `expires=${currentDate.toUTCString()}` : ""
  }`;
};

const getCookie = (key: string) => {
  const v = document.cookie.match(`(^|;) ?${key}=([^;]*)(;|$)`);
  return v ? v[2] : null;
};

const deleteCookie = (key: string) => {
  setCookie(key, "", -1);
};

export default { setCookie, getCookie, deleteCookie };
